function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "key");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "key_2",
  "data-name": "key 2",
  d: "M10.88,0A5,5,0,0,0,5.94,5,5.47,5.47,0,0,0,6,6.07L.59,11.59a2,2,0,0,0,0,2.81h0l1,1a1.94,1.94,0,0,0,2.75,0l0,0L5,14.77a2,2,0,0,0,.93.23,2,2,0,0,0,1.39-.59l1-1a2,2,0,0,0,.36-2.35L9.83,9.89a5.18,5.18,0,0,0,1,.11,5,5,0,0,0,0-10Zm1,7.82a2.71,2.71,0,0,1-1,.18,2.9,2.9,0,0,1-1.54-.44L7.91,9l-2,2,1,1-1,1-1-1L3,14,2,13,6.92,8,8.35,6.56A3,3,0,0,1,7.91,5a2.81,2.81,0,0,1,.18-1,2.94,2.94,0,0,1,2.79-2,3,3,0,0,1,1,5.82Z"
})));

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.88 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.c680bbb3.svg";
export { ForwardRef as ReactComponent };